import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { endOfAppDay, startOfAppDay } from '@/utils/spain-time';
import { createTableFiltersState } from '@/utils/table-filters';

import { ChannelRecordingTaskFilters } from '../../types';

export const useChannelRecordingTaskFilters = createTableFiltersState<ChannelRecordingTaskFilters>({
  tableKey: TableKeyEnum.CHANNEL_RECORDING_TASKS,
  defaultFilterValues: {
    // Today as the Madrid day, whatever the viewer's timezone (RCOMM-6264).
    createdAtGte: startOfAppDay().toISOString(),
    createdAtLte: endOfAppDay().toISOString(),
  },
});
